interface GraphDownArrowWithDollarSignSVGProps {
  color: string;
  style: React.CSSProperties;
}

const GraphDownArrowWithDollarSignSVG = ({
  color,
  style,
}: GraphDownArrowWithDollarSignSVGProps) => (
  <div style={{ display: "flex", alignItems: "baseline" }}>
    <svg
      style={{ paddingBottom: "8px", ...style }}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <g clipPath="url(#clip0_519_19858)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H2.45982V36.8973H39.3571V39.3571H0V0ZM24.5982 28.2879C24.5982 28.6141 24.7278 28.927 24.9584 29.1576C25.1891 29.3883 25.5019 29.5179 25.8281 29.5179H35.6674C35.9936 29.5179 36.3064 29.3883 36.5371 29.1576C36.7677 28.927 36.8973 28.6141 36.8973 28.2879V18.4487C36.8973 18.1225 36.7677 17.8096 36.5371 17.579C36.3064 17.3483 35.9936 17.2188 35.6674 17.2188C35.3412 17.2188 35.0284 17.3483 34.7977 17.579C34.5671 17.8096 34.4375 18.1225 34.4375 18.4487V24.8442L25.5502 13.9792C25.4414 13.8464 25.306 13.7378 25.1527 13.6605C24.9994 13.5832 24.8317 13.5388 24.6602 13.5302C24.4887 13.5217 24.3174 13.5491 24.1572 13.6107C23.9969 13.6724 23.8514 13.7669 23.7299 13.8882L17.3663 20.2517L8.37323 7.88619C8.1765 7.63603 7.89046 7.47187 7.57523 7.4282C7.25999 7.38453 6.9401 7.46476 6.68277 7.65202C6.42545 7.83928 6.25073 8.11899 6.19533 8.43238C6.13993 8.74577 6.20817 9.06843 6.3857 9.33256L16.225 22.8616C16.3294 23.0054 16.4638 23.125 16.6189 23.2119C16.7739 23.2988 16.946 23.3511 17.1232 23.3651C17.3005 23.3792 17.4786 23.3546 17.6454 23.2931C17.8122 23.2317 17.9638 23.1348 18.0895 23.0092L24.5072 16.589L33.0723 27.058H25.8281C25.5019 27.058 25.1891 27.1876 24.9584 27.4183C24.7278 27.6489 24.5982 27.9618 24.5982 28.2879Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_519_19858">
          <rect width="39.3571" height="39.3571" fill={color} />
        </clipPath>
      </defs>
    </svg>
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
    >
      <g clipPath="url(#clip0_519_19860)">
        <path
          d="M8.44714 14.3533C8.44714 15.7927 9.61492 16.974 11.0679 16.974C12.5208 16.974 13.6886 15.8063 13.6886 14.3533C13.6886 12.9004 12.6158 12.235 11.0679 11.7326C9.69639 11.2845 8.44714 10.5649 8.44714 9.11192C8.44714 7.65899 9.61492 6.49121 11.0679 6.49121C12.5208 6.49121 13.6886 7.65899 13.6886 9.11192"
          stroke={color}
          strokeWidth="2.03682"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 5.06641V6.5465"
          stroke={color}
          strokeWidth="2.03682"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 16.9873V18.4674"
          stroke={color}
          strokeWidth="2.03682"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.0001 21.6987C16.4896 21.6987 20.9398 17.2486 20.9398 11.759C20.9398 6.26949 16.4896 1.81934 11.0001 1.81934C5.51057 1.81934 1.06042 6.26949 1.06042 11.759C1.06042 17.2486 5.51057 21.6987 11.0001 21.6987Z"
          stroke={color}
          strokeWidth="2.03682"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_19860">
          <rect
            width="22"
            height="22"
            fill={color}
            transform="translate(0 0.759766)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default GraphDownArrowWithDollarSignSVG;
